import LiveInteractionData from "./live-interaction-data";
import LiveSummaryTab from "./live-summary-tab";
import { FunctionComponent, memo } from "react";
import { IProps } from "./live.types";
import { Page, PageContent, PageHeader } from "@edgetier/client-components";
import { Tabs, TabsButton, TabsButtons, TabsItem, TabsItems } from "@edgetier/tabs";
import "./live.scss";

/**
 * Display live summary data based on tag groups and tags and a breakdown of live interaction data
 * (queuing and interactions being handled).
 * @returns Live summary and breakdown of metrics, charts, and tables.
 */
const Live: FunctionComponent<IProps> = () => {
    return (
        <Page className="live">
            <PageHeader title="Live" />
            <PageContent>
                <Tabs activeTabId="live-summary-data">
                    <TabsButtons>
                        <TabsButton tabId="live-summary-data">Summary</TabsButton>
                        <TabsButton tabId="live-interaction-data">Breakdown</TabsButton>
                    </TabsButtons>
                    <TabsItems>
                        <TabsItem tabId="live-summary-data">
                            <LiveSummaryTab />
                        </TabsItem>
                        <TabsItem tabId="live-interaction-data">
                            <LiveInteractionData />
                        </TabsItem>
                    </TabsItems>
                </Tabs>
            </PageContent>
        </Page>
    );
};

export default memo(Live);
